/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import {
  AppBar,
  Badge,
  Button,
  IconButton,
  Toolbar,
  Hidden,
  Input,
  colors,
  Popper,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ClickAwayListener
} from '@material-ui/core';
import LockIcon from '@material-ui/icons/LockOutlined';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import InputIcon from '@material-ui/icons/Input';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import axios from 'utils/axios';
import useRouter from 'utils/useRouter';
import { PricingModal, NotificationsPopover } from 'components';
import { logout, getOrders } from 'actions';
import { saveUserIpApi } from 'api/user';
import { getIpAddress } from 'helpers/getIp'
import { getDetailsFromIpAddress } from 'helpers/getDetailsFromIp';
import "./header.css"
import { render } from 'react-dom';
import LocationOnIcon from '@material-ui/icons/LocationOn';


const useStyles = makeStyles(theme => ({

  root: {
    boxShadow: 1,
    backgroundColor: 'white'
  },
  flexGrow: {
    flexGrow: 1
  },
  search: {
    backgroundColor: 'rgba(255,255,255, 0.1)',
    borderRadius: 4,
    flexBasis: 300,
    height: 36,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: 'inherit'
  },
  searchInput: {
    flexGrow: 1,
    color: 'inherit',
    '& input::placeholder': {
      opacity: 1,
      color: 'inherit'
    }
  },
  searchPopper: {
    zIndex: theme.zIndex.appBar + 100
  },
  searchPopperContent: {
    marginTop: theme.spacing(1)
  },
  trialButton: {
    marginLeft: theme.spacing(2),
    color: theme.palette.white,
    backgroundColor: colors.green[600],
    '&:hover': {
      backgroundColor: colors.green[900]
    }
  },
  trialIcon: {
    marginRight: theme.spacing(1)
  },
  notificationsButton: {
    marginLeft: theme.spacing(1)
  },
  notificationsBadge: {
    backgroundColor: colors.orange[600]
  },
  logoutButton: {
    marginLeft: theme.spacing(1)
  },
  logoutIcon: {
    marginRight: theme.spacing(1)
  }
}));


const TopBar = props => {
  const { onOpenNavBarMobile, className, ...rest } = props;

  const classes = useStyles();
  const { history } = useRouter();
  const searchRef = useRef(null);
  const dispatch = useDispatch();
  const notificationsRef = useRef(null);
  const [pricingModalOpen, setPricingModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [openSearchPopover, setOpenSearchPopover] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [notifications, setNotifications] = useState([]);
  const [openNotifications, setOpenNotifications] = useState(false);
  const session = useSelector(state => state.session);
  // const user = useSelector(state => state.user);
  const [sidebar, setSidebar] = useState(true);


  useEffect(() => {
    let mounted = true;

    const fetchNotifications = () => {
      axios.get('/api/account/notifications').then(response => {
        if (mounted) {
          setNotifications(response.data.notifications);
        }
      });
    };

    fetchNotifications();

    return () => {
      mounted = false;
    };
  }, []);

  const handleLogout = async () => {
    setLoading(true);
    const ip = await getIpAddress();
    const ipDetails = await getDetailsFromIpAddress(ip);
    // // const string = ipDetails.status == 'success' ? `${ip}, ${ipDetails.city}, ${ipDetails.regionName}, ${ipDetails.country}, ${ipDetails.zip}` : 'Failed to Get IP Location';
    // // const latLong = ipDetails.status == 'success' ? `${ipDetails.lat}, ${ipDetails.lon}` : 'Failed to Get IP Lat Long';
    const string = !ipDetails.error ? `${ip}, ${ipDetails.city}, ${ipDetails.region}, ${ipDetails.country_name}, ${ipDetails.postal}` : 'Failed to Get IP Location';
    const latLong = !ipDetails.error ? `${ipDetails.latitude}, ${ipDetails.longitude}` : 'Failed to Get IP Lat Long';
    const clientId = session.user.clientID;
    const userName = session.user.Username;
    const requestBody = {
      'clientId': clientId,
      'userName': userName,
      'latLong': latLong,
      'isLoggedIn': 0,
      'ip': string,
      'platformId': '2'
    }

    const captureUserInfo = await saveUserIpApi(requestBody);
    // dispatch(getOrders([]));
    localStorage.setItem('userData', null)
    dispatch(logout());
    history.push('/auth/login');
    setLoading(false);
  };

  const handlePricingOpen = () => {
    setPricingModalOpen(true);
  };

  const handlePricingClose = () => {
    setPricingModalOpen(false);
  };

  const handleNotificationsOpen = () => {
    setOpenNotifications(true);
  };

  const handleNotificationsClose = () => {
    setOpenNotifications(false);
  };

  const handleSearchChange = event => {
    setSearchValue(event.target.value);

    if (event.target.value) {
      if (!openSearchPopover) {
        setOpenSearchPopover(true);
      }
    } else {
      setOpenSearchPopover(false);
    }
  };

  const handleSearchPopverClose = () => {
    setOpenSearchPopover(false);
  };

  const handleCreateNewOrder = async () => {
    history.push('/orders/create/new');
  }


  const openCloseSidebar = () => {
    if (sidebar) {
      setSidebar(false);
      document
        .querySelector(".MuiPaper-elevation1").style.transition = "0.5s"
      document
        .querySelector(".MuiPaper-elevation1").style.transform = "translate(-256px)"
      document
        .querySelector(".MuiPaper-elevation1").style.width = "0px"
      document
        .querySelector(".MuiPaper-elevation1").style.minWidth = "0px"

      // .classList.add("sidebar-close");
      // .styleList.display("none");
    } else {
      setSidebar(true);
      document
        .querySelector(".MuiPaper-elevation1").style.transition = "0.5s"
      document
        .querySelector(".MuiPaper-elevation1").style.transform = "translate(0px)"
      document
        .querySelector(".MuiPaper-elevation1").style.width = "256px"
      document
        .querySelector(".MuiPaper-elevation1").style.minWidth = "256px"

    }
  };
  const popularSearches = [
    'Devias React Dashboard',
    'Devias',
    'Admin Pannel',
    'Project',
    'Pages'
  ];


  return (
    <AppBar {...rest} className={clsx(classes.root, className)} color="primary">
      <Toolbar>
        <Hidden mdDown>
          <span>
            <img
              alt="Logo"
              height="60"
              src="/images/logos/NEXT DAY-20.svg"
              width="200"
            />
          </span>
          <div className={classes.flexGrow}>
            <div className="mobile-sidebar">
              <div className="media-body text-right switch-sm" >
                <label className="switch">
                  <input
                    type="checkbox"
                    id="sidebar-toggle"
                    defaultChecked={sidebar}
                    onClick={openCloseSidebar}
                  />
                  <span className="switch-state" style={{ backgroundColor: "#ea4444" }}></span>
                </label>
              </div>
            </div>
          </div>
        </Hidden>
        <div className={classes.flexGrow} />

        <Hidden mdDown >
          {session.loggedIn &&
            <Button
              className={classes.logoutButton}
              // color="black"
              onClick={handleCreateNewOrder}
              style={{ color: 'black' }}
            >
              <AddCircleOutlineIcon className={classes.logoutIcon} />
              New Order
            </Button>
          }

          {session.loggedIn &&
            <Button
              className={classes.logoutButton}
              // color="black"
              disabled={loading}
              onClick={handleLogout}
              style={{ color: 'black' }}
            >
              {/* <InputIcon className={classes.logoutIcon} /> */}
              {/* Sign out */}
              {
                loading ?
                  <span><i className="fa fa-refresh fa-spin" style={{ marginRight: '5px' }} /> Signing Out </span> :
                  <span><i className="fa fa-sign-out" style={{ marginRight: '5px' }} /> Sign Out </span>
                // <InputIcon className={classes.logoutIcon} /> Sign Out
              }
            </Button>
          }

          {session.loggedIn == '' && <Button
            // className={classes.logoutButton}
            // color="black"
            disabled='true'
            onClick={handleLogout}
            style={{ color: 'black' }}
          >
            {/* <InputIcon className={classes.logoutIcon} /> */}
            {/* Sign out */}
            {
              loading ?
                <span><i className="fa fa-refresh fa-spin" style={{ marginRight: '5px' }} />  </span> :
                <span><LocationOnIcon />Track Order </span>
              // <InputIcon className={classes.logoutIcon} /> Sign Out
            }
          </Button>}



        </Hidden>
        <Hidden lgUp>
          <IconButton color="inherit" style={{ color: '#546e7a' }} onClick={onOpenNavBarMobile}>
            <MenuIcon />
          </IconButton>
        </Hidden>
        {/* //add here */}

      </Toolbar>
      <PricingModal onClose={handlePricingClose} open={pricingModalOpen} />
      <NotificationsPopover
        anchorEl={notificationsRef.current}
        notifications={notifications}
        onClose={handleNotificationsClose}
        open={openNotifications}
      />
    </AppBar>
  );
};





TopBar.propTypes = {
  className: PropTypes.string,
  onOpenNavBarMobile: PropTypes.func
};


export default TopBar;
